
import {Observable } from 'rxjs';
import { JwtHelperService } from "@auth0/angular-jwt";
import { Injectable, inject } from '@angular/core';
import  {EnvironmentConfiguration} from '../../environment/services/environment.configuration'
import { Router, ActivatedRoute, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateFn }
  from '@angular/router';
import { ActionsSubject, Store } from '@ngrx/store';
import { getAuthAccess } from 'src/app/core/state/selectors';
import { AuthServiceForgerock } from './auth-service.service';
import * as appCustomerInfoActions from '../state/actions/dealer-detail-auth.action';
import * as models from '../../shared/model/api/AuthData';
import * as roleModels from '../../shared/model/api/RouteConfiguration';
import * as authDataActions from '../state/actions/auth-data.action';
import { ViewConstants } from '../../constants';
import { AuthorizationRouteConfiguration } from '../json/authorization-route-configutation';
import { Logger } from './logger';
import { isNil } from 'lodash-es';
import { SharedFunctionService } from './shared-func.service';
import { WindowWrapper } from './windowwrapper';
import { SharedDataService } from './shared-data.service';
import { AppState } from '../../state/app.state';
import { ofType } from '@ngrx/effects';
import { Subscription } from 'rxjs/internal/Subscription';
import { IdleTimeoutService } from './idle-timeout.service';
import * as _lodash from 'lodash';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConAppIdleTimeoutModalComponent } from '../components/general/con-app-idle-timeout-modal/con-app-idle-timeout-modal.component'

declare function checkCanary(userId : any);



@Injectable(
  {providedIn: 'root'}
)
export class AuthGuardService{
  private userEventSubscription: Subscription = new Subscription();
  // to store route params subscriber
  routeParmaSubscriber: any;
  public user : any;
  // variable to hold the auth data
  private authData$: Observable<models.AuthData>;
  // Variable to hold the roles and routes map
  private rolesRouteMap: Array<roleModels.Roles> = [];
  // Subscriber for Token Refresh Timer
  private tokenRefresher$: any = null;
  // Subscriber for Token Validator Timer
  private tokenValidator$: any = null;
  private dealerUser: string = 'Dealer-User';
  private closeEmptyRightPanel: string = 'false';
  private sessionTimeoutInMinutes: number = 60; // idle timeout in minutes
  public subsc = new Subscription();
  public _subsc = new Subscription();
  nextTokenUpdateTime : any;
  customerId: string;
  private sessionCookieValiationTimer;
  // constructor for to create instances
  constructor(public window: WindowWrapper,
    public authService: AuthServiceForgerock,
    private router: Router, private route: ActivatedRoute,
    private store: Store<AppState>,
    private logger: Logger,
    private sharedFunctionService: SharedFunctionService,
    private dialog: MatDialog,
    private sharedDataService: SharedDataService,
    private idleService: IdleTimeoutService,
    private environment : EnvironmentConfiguration,private actionsSubj: ActionsSubject) {
     
      // this.authData$ = store.select(fromSelectors.getAuthData);
      this.subsc = this.actionsSubj.pipe(
        ofType(appCustomerInfoActions.LoadUserInfoSuccessAction)
    ).subscribe(data => {
      this.authService.loggedIn = true;
      this.authService.currentUser = this.user;
      this.authService.currentUser.profile.roles=data['response']['roles'];
      this.authService.currentUser.profile.UserId=data['response']['UserId'];
      if (typeof checkCanary === 'function') {
        if(this.authService.currentUser && this.authService.currentUser.profile && this.authService.currentUser.profile.UserId) {
          checkCanary(this.authService.currentUser.profile.UserId.toLowerCase());
        }
      }
      this.authService.currentUser.profile.user_type = data['response']['user_type'];
      if (this.authService && this.authService.currentUser && this.authService.currentUser.profile && this.authService.currentUser.profile.user_type) {
        if (this.authService.currentUser.profile.user_type.toLowerCase() === this.dealerUser.toLowerCase()) {
          this.authService.currentUser['dealerCode'] = data['response']['dealer_number'];
          if(this.authService.currentUser.profile['dealer_number'] && this.authService.currentUser['dealerCode'] && this.authService.currentUser.profile['dealer_number'] !==  this.authService.currentUser['dealerCode']){
            this.sharedFunctionService.logout(this.window);
          }
        } else {
          this.authService.currentUser['dealerCode'] = this.getDealerCodeFromUserProfile(data['response'], 'primary_dealer_number');
          if(this.authService.currentUser.profile['primary_dealer_number'] &&  this.authService.currentUser['dealerCode'] && this.authService.currentUser.profile['primary_dealer_number'] !==  this.authService.currentUser['dealerCode']){
            this.sharedFunctionService.logout(this.window);
          }
        }
      }

      //console.log(""+this.authService.currentUser.profile.UserId+"")
      // Check for Dealer user or Corporate user
      // for dealer user user 'dealer_number'
      // for corporate user 'primary_dealer_number'
      if(AuthorizationRouteConfiguration.USER_RTI_RETAIL_DELETE_FEATURE_ROLE
        .filter(dt => dt === this.authService.currentUser.profile.UserId).length > 0
        && this.authService.currentUser.profile.roles
          .indexOf(ViewConstants.DD_RTIRETAILDELETEFEATURE) === -1) {
            this.authService.currentUser.profile.roles += 
              "," + ViewConstants.DD_RTIRETAILDELETEFEATURE;
      }
      if (!isNil(this.authService.currentUser.profile.user_type)
        && this.authService.currentUser.profile.user_type.toString() !== ''
        && this.authService.currentUser.profile.user_type.toString() === this.dealerUser) { // Dealer user
        let userDealerCode = this.getDealerCodeFromUserProfile(data['response'], 'dealer_number');
        if (userDealerCode !== '') {
          this.authService.currentUser['dealerCode'] = userDealerCode;
        } else {
          this.authService.currentUser['dealerCode'] =
            this.getDealerCodeFromUserProfile(data['response'], 'primary_dealer_number');
        }
      } else { // Corporate user
        this.authService.currentUser['dealerCode'] =
          this.getDealerCodeFromUserProfile(data['response'], 'primary_dealer_number');
      }

      // if (!isNil(user.profile.dealer_number) &&
      //   user.profile.dealer_number.toString() !== '') {
      //   this.authService.currentUser['dealerCode'] = user.profile.dealer_number;
      // } else {
      //   this.authService.currentUser['dealerCode'] = user.profile.primary_dealer_number;
      // }

      // Setting User Id and User Type of the Customer              
      if(!isNil(data) && !isNil(data['response'])) {
        let customerDetails = data['response'];
        this.sharedDataService.setUserIdUserType(customerDetails['UserId'], customerDetails['user_type'], customerDetails['given_name'], customerDetails['family_name'])
      }

      this.authService.originalRouteURL = sessionStorage.getItem('originalUrl');
      //temp fixes
      // this.authService.originalRouteURL = this.authService.baseURL + '/customer-deal/writeUps'
      this.logger.log('original url');
      this.logger.log(this.authService.originalRouteURL);

      if (this.isUserAuthorized() || this.sharedDataService.isUserSalesConsultant) {
        this.authService.scheduleRefreshToken();
        this.startIdleTimeout();
        this.window.sessionStorage.setItem(ViewConstants.ID_TOKEN_HTTP_CLIENT,this.user.id_token);
        this.window.sessionStorage.setItem(ViewConstants.ACCESS_TOKEN_HTTP_CLIENT,this.user.access_token);
        this.window.sessionStorage.setItem('closeEmptyRightPanel', this.closeEmptyRightPanel ? this.closeEmptyRightPanel : 'false');
          // if(!isNil(this.authService) && !isNil(this.authService.currentUser))
          // this.store.dispatch(new dealerDetailActions.DealerConfigAction(this.authService.currentUser['dealerCode']));
        this.store.dispatch(authDataActions.SetLoggedInUserDataAction({payload:this.authService.currentUser}));
      if(!this.sharedDataService.isUserSalesConsultant){
        if (!isNil(this.authService.originalRouteURL) &&
        this.authService.originalRouteURL !== '') {
        this.router.navigateByUrl(this.authService.originalRouteURL.replace(this.authService.baseURL, ''));
        } else {
          this.router.navigate(['']);
        }
        const cv_queryString = window.localStorage.getItem('cv_queryString');
        if(cv_queryString == null && !this.authService.originalRouteURL.includes('sharedsaves')) this.router.navigate(['/wl/summary'])
      }else{
        if(this.authService.originalRouteURL.includes('sharedsaves')){
          this.router.navigateByUrl(this.authService.originalRouteURL.replace(this.authService.baseURL, ''));
        }else{
          this.router.navigate(['/unauthorized']);
        }
      }
      } else {
        // TODO: redirect to unauthorized page - show message
        this.router.navigate(['/unauthorized']);
      }
      });
  }




ngOnDestroy() {
  this.subsc.unsubscribe();
  this._subsc.unsubscribe();
  if (this.sessionCookieValiationTimer) {
    clearTimeout(this.sessionCookieValiationTimer);
  }
}
  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {
    return this.canActivate(route, state);
  }
  canActivate(activatedRouteSnapShot: ActivatedRouteSnapshot,
    routerStateSnapshot: RouterStateSnapshot) {
    return new Observable<boolean>(observer => { 
      if (this.authService.loggedIn) {
        this.store.select(getAuthAccess).subscribe( o => {
          if (o !== null) {
            if (this.sharedDataService.smartPathDealer) {
              observer.next(true);
              observer.complete();
            }
            else {
              this.navigateFailedRoutes(activatedRouteSnapShot);
              observer.next(false);
              observer.complete();
            }
          }   
        });
      } else {
        this.doSilentLogin();
        observer.next(false);
        observer.complete();
      }
    });
    
  }

  isUserAuthorized() {
    if (this.authService && this.authService.currentUser &&
      (this.authService.currentUser.profile.roles
        .indexOf(ViewConstants.DD_RTI_MST_CONSOLE) > -1 )) {
          this.sharedDataService.isUserAuthorized = true;
      return true;
    } else {
      this.sharedDataService.isUserAuthorized = false;
      return false;
    }
  }

  /***
   * Method to determine to which route redirection should happen
   */
  navigateFailedRoutes(activatedRouteSnapShot: ActivatedRouteSnapshot) {
    this.router.navigate(['/unauthorized']);
  }

  /***
   * Method to check if the dealer has the feature or not
   */
  // hasDealerFeature(activatedRouteSnapShot: ActivatedRouteSnapshot): Observable<boolean> {
  //   return new Observable<boolean>(observer => {
  //     if (activatedRouteSnapShot && activatedRouteSnapShot.url.length > 0
  //       && activatedRouteSnapShot.url[0].path) {
  //       this.autorizationService.hasDealerRoutePathAccess(
  //         this.authService.currentUser['dealerCode'], activatedRouteSnapShot.url[0].path)
  //         .subscribe(hasAccess => {
  //           observer.next(hasAccess);
  //           observer.complete();
  //         });
  //     } else {
  //       observer.next(false);
  //       observer.complete();
  //     }
  //   });
  // }

  /***
   * Method to check if the user role has access to a page or not
   */
  hasPageAccessForRole(activatedRouteSnapShot: ActivatedRouteSnapshot): boolean {
    let isPageAccess: boolean = false;
    let userRoles: Array<string> = [];
 
   
    userRoles = this.authService.currentUser.profile.roles.split(ViewConstants.COMMA);
    if (userRoles && activatedRouteSnapShot && activatedRouteSnapShot.url.length > 0
      && activatedRouteSnapShot.url[0].path) {
      userRoles.forEach(dt => {
        this.rolesRouteMap = AuthorizationRouteConfiguration.routeConfiguration.Roles
          .filter(roles => roles.RoleName === dt);
        if (this.rolesRouteMap.length === 1 &&
          this.rolesRouteMap[0].Routes.filter(rt => activatedRouteSnapShot.url[0].path ===
            rt.RoutePath).length > 0) {
          isPageAccess = true;
        }
      });
    }
    return isPageAccess;
  }

  /***
   * Method to get the query string value
   */
  getQueryStringValue(url: string, key: string) {
    //this.logger.log('inside retrieve param');
    return decodeURIComponent(url.replace(new RegExp('^(?:.*[&\\?]' +
      encodeURIComponent(key).
        replace(/[\.\+\*]/g, '\\$&') + '(?:\\=([^&]*))?)?.*$', 'i'), '$1'));
  }  

  doSilentLogin() {
    let that = this;
    this.closeEmptyRightPanel = this.closeEmptyRightPanel ? this.window.sessionStorage.getItem('closeEmptyRightPanel') : 'false';
    // window.location.hash != null && 
    if (this.window.location.href.indexOf('state') > -1) {
      // e2e endpoint hack - redirect from test env to e2e
      // if (this.window.location.href.indexOf('ui-e2e') > -1) {
      //   this.logger.log('URL redirection from test to e2e triggered');
      //   this.window.location.href = '';
      // }
      // let urlFragment = this.authService.originalRouteURL +
      //   decodeURIComponent(this.window.location.hash);
       let urlFragment = decodeURIComponent(window.location.href);
      this.authService.endSigninMainWindow(urlFragment).then(e => {
        this.authService.getUser()
          .then((user) => {
            console.log("****************this is the User************"+user)
            if (user) {
              this.user=user;
              this.window.sessionStorage.setItem(ViewConstants.ACCESS_TOKEN_HTTP_CLIENT,user.access_token);

            
              that.invokeUserInfoService();
          
            } else {
              this.authService.loggedIn = false;
              // TODO: Might not be needed
              // this.router.navigate(['unauthenticated']);
            }
          });

        // let authService = this.authService;
        // TODO: for idle session time out
        // setTimeout(function() {
        // this.appState.set('user', authService.getUser());
        // },0);
      });
    } else {
      let setgstOriginalBaseURL=this.window.sessionStorage.getItem('originalUrl');
      this.window.sessionStorage.clear();
      this.window.localStorage.removeItem(ViewConstants.REFRESH_TOKEN_INVOKED);
      if(setgstOriginalBaseURL)
      {
        this.window.sessionStorage.setItem('originalUrl', setgstOriginalBaseURL);
      } 
      else{
         this.window.sessionStorage.setItem('originalUrl', this.window.location.href);
      }      
      this.window.sessionStorage.setItem('baseUrl', this.environment.AUTH_BASE_URL);
      this.logger.log('actual base url');
      this.logger.log( this.environment.AUTH_BASE_URL);
      if(setgstOriginalBaseURL){
        this.authService.originalRouteURL = setgstOriginalBaseURL;
        this.authService.startSigninMainWindow(setgstOriginalBaseURL,false);
      }else{
        this.authService.originalRouteURL = this.window.location.href;
        this.authService.startSigninMainWindow(this.window.location.href,false);
      }    
      this.window.sessionStorage.setItem('closeEmptyRightPanel', this.closeEmptyRightPanel);
    }
  }

  /**
   * Method to get the Dealer Code from the User profile
   */
  getDealerCodeFromUserProfile(user: any, fieldName: string): string {
    if (!isNil(user[fieldName]) &&
      user[fieldName].toString() !== '') {
      return user[fieldName];
    } else {
      return '';
    }
  }
  invokeUserInfoService() {
    this.store.dispatch(appCustomerInfoActions.LoadUserInfoAction());
  }
  isSessionExpiryAlertAlreadyDisplayed() {
    return this.dialog.getDialogById('conSessionExpiryDialog');
}
  resetIdleTimer() {
    this.idleService.resetIdleTimer();
  }
  startIdleTimeout() {
    const idleTimeoutInSeconds = this.sessionTimeoutInMinutes * 60;
    this.idleService.initiateIdleTimer(idleTimeoutInSeconds).subscribe((isTimeOut: boolean) => {
      // below code not needed as we are already  doing same in startUserSessionTimer() metthod which is getting called below.
      
        // if (isTimeOut) {
        //     this.sessionExpiredAlert();
        // }
    });
    this.userEventSubscription = this.idleService.userEvents.subscribe(() => {
        // if session expiry alert is already displayed then no need to check user actions
        if (_lodash.isNil(this.isSessionExpiryAlertAlreadyDisplayed())) {
            this.resetIdleTimer();
        }
    });
    this.startUserSessionTimer();
  }
  private sessionExpiredAlert(sessionExpired = true) {
    if(sessionExpired) {
        this.idleService.sessionExpireMinRemaining.next(0);
    }
    this.openIdleUserDialog(sessionExpired);
  }
  openIdleUserDialog(expired) {
    if (_lodash.isNil(this.isSessionExpiryAlertAlreadyDisplayed())) { // if alert already exists
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.hasBackdrop = true;
        dialogConfig.autoFocus = true;
        dialogConfig.id = "conSessionExpiryDialog";
        dialogConfig.data = {
            sessionExpired: expired
        }

        const dialogRef = this.dialog.open(ConAppIdleTimeoutModalComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(data => {
            if (data === 'extend') {
              this.nextTokenUpdateTime = new Date(new Date().getTime()
              + AuthServiceForgerock.REFRESH_TOKEN_TIME_PERIOD).toLocaleTimeString();
              console.log('************************ NEXT SILENT TESS TOKEN UPDATE on ************************ ' + this.nextTokenUpdateTime);
                this.extendUserSession();

            } else {
              this.sharedFunctionService.logout(this.window);
            }
        });
    }
  }

  private extendUserSession() {
    this.authService.startRefreshToken();
    this.idleService.sessionExpireMinRemaining.next(60);
    this.startUserSessionTimer();
    this.idleService.resetIdleTimer();
  }
  public accessTokenRemainingTime() {
    let jwtHelper = new JwtHelperService();
    const accessTokenTime = jwtHelper.getTokenExpirationDate( this.window.sessionStorage.getItem(ViewConstants.ACCESS_TOKEN_HTTP_CLIENT)) as Date;
    const remainingTimeMilliSeconds = accessTokenTime.getTime() - (new Date().getTime());
    const remainingTimeInMin = remainingTimeMilliSeconds / 60000;
    return remainingTimeInMin;
  }
  public isAccessOrRefreshTokenExpired() {
    let jwtHelper = new JwtHelperService();
    return jwtHelper.isTokenExpired(this.window.sessionStorage.getItem(ViewConstants.ACCESS_TOKEN_HTTP_CLIENT));//|| jwtHelper.isTokenExpired(this.commonUtilities.refresh_token);
  }
  public startUserSessionTimer() {
    this.sessionCookieValiationTimer = setInterval(() => {

        const isForgerockCookieExit = this.idleService.isForgerockCookieExit();
        let tokenExpired = this.isAccessOrRefreshTokenExpired();
        if (_lodash.isNil(isForgerockCookieExit) || isForgerockCookieExit === '' || tokenExpired) {
            console.log('CON SESSION ************ _lodash.isNil(isForgerockCookieExit) || tokenExpired ********************************** ');
            this.sessionExpiredAlert();
        } else {
            let remainingTime = this.idleService.userSessionRemaining();
            if (remainingTime === 0) {
                this.sessionExpiredAlert();
                console.log('CON SESSION ************ DDSessionTimer remainingTime = 0 ********************************** ');
            } else if (remainingTime < 10) {
                this.sessionExpiredAlert(false);
                this.idleService.sessionExpireMinRemaining.next(remainingTime);
                console.log(`CON SESSION ************ DDSessionTimer remainingTime = ${remainingTime} ********************************** `);
            } else {
                let accessTokenRemainingTime = this.accessTokenRemainingTime();

                if (accessTokenRemainingTime < 6 && _lodash.isNil(this.isSessionExpiryAlertAlreadyDisplayed())) {
                    console.log(`CON SESSION ************ DDSessionTimer accessTokenRemainingTime = ${accessTokenRemainingTime} ********************************** `);
                    this.authService.startRefreshToken();
                }
            }
        }
    }, 30000);
  }
}
// export const AuthGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> => {
//   return inject(AuthGuardService).canActivate(next, state)
// }